import style from "styled-components";

export const NumberFormat = style.span`
   font-size:${({ theme }) => theme.fontSizes.small};
   font-weight: 900;
   color:black;
   text-align:center;
`;
